import BaseAbility from 'umg-ember-backend/abilities/base';

export default class AssetFormatAbility extends BaseAbility {}
